import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import ShefCouponForm from "../components/coupon/ShefCouponForm";
import {
  handleDeleteDiscount,
  handleGetDiscountWithMenus,
  handleUpdateDiscountStatus,
  handleGetChefDiscount
} from "../../services/shef";
import { useSelector } from "react-redux";
import BeforeFooter from "../../frontend/components/homeWidget/BeforeFooter";
import Footer from "../../frontend/components/Footer";


const ShefCoupon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [discountWithMenus, setDiscountWithMenus] = useState();
  const [discountIdToDelete, setDiscountIdToDelete] = useState(null);
  const { authToken, userInfo } = useSelector((state) => state.user);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const closeCouponModal = () => setIsModalOpen(false);
  const closeEditCouponModal = () => setIsEditModalOpen(false);
  const onCouponSubmit = () => setFormSubmitted((pre) => !pre);

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const discountsArray = await handleGetChefDiscount(authToken);
        console.log("Discounts Array",discountsArray)
        setDiscounts(discountsArray.data);
      } catch (error) {
        console.error("Error fetching discounts", error.message);
      }
    };
    fetchDiscount();
  }, [authToken, formSubmitted]);

  const openEditModal = async (id) => {
    try {
      const discountsWithMenus = await handleGetDiscountWithMenus(authToken, id);
      setDiscountWithMenus(discountsWithMenus.original);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching discounts", error.message);
    }
  };

  const openDeleteConfirmationModal = (id) => {
    setDiscountIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDiscountIdToDelete(null);
  };

  const handleDeleteDiscountConfirm = async () => {
    try {
      await handleDeleteDiscount(authToken, discountIdToDelete);
      setDiscounts(discounts.filter((discount) => discount.id !== discountIdToDelete));
      closeDeleteModal();
    } catch (error) {
      console.error("Error deleting discount", error.message);
    }
  };

  const handleToggleStatus = async (row) => {
    try {
      const discountsWithMenus = await handleGetDiscountWithMenus(authToken, row.id);
      const discount = discountsWithMenus.original;
      const updatedStatus = discount.status === 1 ? 0 : 1;
      const updatedDiscount = { ...discount, status: updatedStatus };
      await handleUpdateDiscountStatus(authToken, discount.id, updatedDiscount);
      setDiscounts((prev) => prev.map((d) => (d.id === discount.id ? { ...d, status: updatedStatus } : d)));
    } catch (error) {
      console.error("Error updating discount status", error.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />
      <div className="container mx-auto p-6">
        <div className="bg-white rounded-2xl shadow-md p-6 mb-8 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
            <span className="w-10 h-10 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center text-white text-lg">🎫</span>
            SHEF COUPONS
          </h1>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-red-600 hover:bg-red-700 text-white py-2 px-6 rounded-lg font-semibold shadow-md w-full sm:w-auto"
          >
            Add Coupon
          </button>
        </div>

        {discounts.length === 0 ? (
          <div className="text-center py-20 text-gray-500">
            <div className="text-5xl mb-4">😔</div>
            <p className="text-lg">No coupons available</p>
            <p className="text-sm">Click "Add Coupon" to create one.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {discounts.map((discount) => (
              <div key={discount.id} className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300">
                <div className="bg-gradient-to-br from-red-600 to-red-700 text-white p-6 relative">
                  <h2 className="text-3xl font-bold mb-1">
                    {discount.discount_type === '$' ? 'Rs. ' + discount.discount : discount.discount + '%'} OFF
                  </h2>
                  <p className="uppercase text-xs tracking-wider opacity-90">{discount.coupon_title || "Shef Coupon"}</p>
                </div>
                <div className="p-6">
                  <div className="border-2 border-dashed border-gray-300 rounded-md p-4 mb-4 text-center">
                    <div className="text-xs text-gray-500 uppercase tracking-wider">Coupon Code</div>
                    <div className="text-lg font-mono font-bold text-red-600">{discount.code || 'NA'}</div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <div className="text-xs uppercase text-gray-500">Start Date</div>
                      <div className="text-base font-semibold">{formatDate(discount.start_date)}</div>
                    </div>
                    <div>
                      <div className="text-xs uppercase text-gray-500">End Date</div>
                      <div className="text-base font-semibold">{formatDate(discount.end_date)}</div>
                    </div>
                  </div>

                  <div className="flex justify-between items-center mb-4">
                    <span
                      className={`text-xs font-semibold px-3 py-1 rounded-full ${
                        discount.status === 1
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-600'
                      }`}
                    >
                      {discount.status === 1 ? 'Active' : 'Inactive'}
                    </span>
                    <div className="flex gap-2">
                      <button
                        onClick={() => openEditModal(discount.id)}
                        className="bg-yellow-400 hover:bg-yellow-500 text-black px-3 py-1 rounded text-sm font-semibold"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => openDeleteConfirmationModal(discount.id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm font-semibold"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isDeleteModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-8 w-full max-w-sm">
            <h3 className="text-xl font-bold mb-4">Delete Confirmation</h3>
            <p className="mb-6">Are you sure you want to delete this coupon?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={closeDeleteModal}
                className="bg-gray-300 text-black px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteDiscountConfirm}
                className="bg-red-600 text-white px-4 py-2 rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && discountWithMenus && (
        <ShefCouponForm
          isOpen={isEditModalOpen}
          onClose={closeEditCouponModal}
          discountWithMenus={discountWithMenus}
          fetchDiscount={onCouponSubmit}
        />
      )}

      {isModalOpen && (
        <ShefCouponForm
          isOpen={isModalOpen}
          onClose={closeCouponModal}
          editParameters={null}
          fetchDiscount={onCouponSubmit}
        />
      )}

      <Footer />
    </div>
  );
};

export default ShefCoupon;

